import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, DetailFilterParams, GroupFilterParams} from './types';

export const actions: ActionTree<StatisticState, RootState> = {
  async getViberStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/viber',
        params: data
      });
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit('pushViberStatisticDetail', messages);
      } else {
        commit('setViberStatisticDetail', messages);
      }
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async exportViberStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/viber/export',
        params: data
      });
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async getViberStatisticDetailInfo({commit, dispatch}, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/viber/" + id.replace(/#/g, "%23"),
      })
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async getViberStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/viber',
        params: data
      });
      commit('setViberStatisticGroup', resp.data);
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async exportViberStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/viber/export',
        params: data
      });
      return resp;
    } catch (error) {
      throw error;
    }
  },
};